// @ts-nocheck
import {
  GET_ALL_CONTRACTS_FAILURE,
  GET_ALL_CONTRACTS_REQUEST,
  GET_ALL_CONTRACTS_SUCCESS,
  GET_ALL_NEW_CONTRACTS_REQUEST,
  GET_ALL_NEW_CONTRACTS_FAILURE,
  GET_ALL_NEW_CONTRACTS_SUCCESS,
  GET_UNDER_REVIEW_CONTRACTS_REQUEST,
  GET_UNDER_REVIEW_CONTRACTS_FAILURE,
  GET_UNDER_REVIEW_CONTRACTS_SUCCESS,
  GET_ALL_VERIFIED_CONTRACTS_FAILURE,
  GET_ALL_VERIFIED_CONTRACTS_REQUEST,
  GET_ALL_VERIFIED_CONTRACTS_SUCCESS,
  GET_SIGNATURE_SUCCESS,
  ADD_SIGNATURE_SUCCESS,
  EDIT_SIGNATURE_SUCCESS,
  DELETE_SIGNATURE_SUCCESS,
} from "../../constants/contract/contract";

const initialState = {
  allContracts: {
    data: [],
    isLoading: false,
    searchString: "",
    totalPages: 0,
    currentPage: 0,
  },
  newContracts: {
    data: [],
    isLoading: false,
    searchString: "",
    totalPages: 0,
    currentPage: 0,
  },
  underReviewContracts: {
    data: [],
    isLoading: false,
    searchString: "",
    totalPages: 0,
    currentPage: 0,
  },
  verifiedContracts: {
    data: [],
    isLoading: false,
    searchString: "",
    totalPages: 0,
    currentPage: 0,
  },
  contractDetails: {},
  contractPresets: {
    savedSignature: [],
    savedText: [],
  },
};

const allContractReducer = (state = initialState, action) => {
  switch (action?.type) {
    // all contracts
    case GET_ALL_CONTRACTS_REQUEST:
      return {
        ...state,
        allContracts: {
          ...state?.allContracts,
          isLoading: true,
          searchString: action?.payload?.searchString,
        },
      };

    case GET_ALL_CONTRACTS_FAILURE:
      return {
        ...state,
        allContracts: {
          ...state?.allContracts,
          isLoading: false,
        },
      };

    case GET_ALL_CONTRACTS_SUCCESS:
      return {
        ...state,
        allContracts: {
          ...state?.allContracts,
          isLoading: false,
          data: action?.payload?.data,
          totalPages: action?.payload?.meta?.totalPages,
          currentPage: action?.payload?.meta?.page,
        },
      };

    // all new contracts
    case GET_ALL_NEW_CONTRACTS_REQUEST:
      return {
        ...state,
        newContracts: {
          ...state?.newContracts,
          isLoading: true,
          searchString: action?.payload?.searchString,
        },
      };

    case GET_ALL_NEW_CONTRACTS_FAILURE:
      return {
        ...state,
        newContracts: {
          ...state?.newContracts,
          isLoading: false,
        },
      };

    case GET_ALL_NEW_CONTRACTS_SUCCESS:
      return {
        ...state,
        newContracts: {
          ...state?.newContracts,
          isLoading: false,
          data: action?.payload?.data,
          totalPages: action?.payload?.meta?.totalPages,
          currentPage: action?.payload?.meta?.page,
        },
      };

    // under review contracts
    case GET_UNDER_REVIEW_CONTRACTS_REQUEST:
      return {
        ...state,
        underReviewContracts: {
          ...state?.underReviewContracts,
          isLoading: true,
          searchString: action?.payload?.searchString,
        },
      };

    case GET_UNDER_REVIEW_CONTRACTS_FAILURE:
      return {
        ...state,
        underReviewContracts: {
          ...state?.underReviewContracts,
          isLoading: false,
        },
      };

    case GET_UNDER_REVIEW_CONTRACTS_SUCCESS:
      return {
        ...state,
        underReviewContracts: {
          ...state?.underReviewContracts,
          isLoading: false,
          data: action?.payload?.data,
          totalPages: action?.payload?.meta?.totalPages,
          currentPage: action?.payload?.meta?.page,
        },
      };

    // verified contracts
    case GET_ALL_VERIFIED_CONTRACTS_REQUEST:
      return {
        ...state,
        verifiedContracts: {
          ...state?.verifiedContracts,
          isLoading: true,
          searchString: action?.payload?.searchString,
        },
      };

    case GET_ALL_VERIFIED_CONTRACTS_FAILURE:
      return {
        ...state,
        verifiedContracts: {
          ...state?.verifiedContracts,
          isLoading: false,
        },
      };

    case GET_ALL_VERIFIED_CONTRACTS_SUCCESS:
      return {
        ...state,
        verifiedContracts: {
          ...state?.verifiedContracts,
          isLoading: false,
          data: action?.payload?.data,
          totalPages: action?.payload?.meta?.totalPages,
          currentPage: action?.payload?.meta?.page,
        },
      };

    // get saved signatures
    case GET_SIGNATURE_SUCCESS:
      return {
        ...state,
        contractPresets: action?.payload,
      };

    // add signatures
    case ADD_SIGNATURE_SUCCESS:
      return {
        ...state,
        contractPresets: action?.payload,
      };

    // edit signatures
    case EDIT_SIGNATURE_SUCCESS:
      return {
        ...state,
        contractPresets: action?.payload,
      };

    case DELETE_SIGNATURE_SUCCESS:
      return {
        ...state,
        contractPresets: action?.payload,
      };

    // delete signatures (we won't do anything but on add end edit we'll add the latest data  )

    // add signatures
    default:
      return state;
  }
};

export default allContractReducer;